module.exports = __webpack_public_path__ + "img/2019112001.a3b0d091.jpg";